import * as React from 'react';
import { observer } from 'mobx-react';

import { Button } from 'shared/newComponents/buttons';
import { ComponentType } from 'shared/entities/components/Component';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import { useRouterStore, useUiStore } from 'stores/index';
import { urls } from 'shared/entities/domain';

type Props = {
  className?: string;
};

const ReferralButton: React.FC<Props> = ({ className }: Props) => {
  const routerStore = useRouterStore();
  const uiStore = useUiStore();

  const handleClick = React.useCallback(() => {
    routerStore.push(urls.SETTINGS.CABINET.REFERRAL.create());
    if (uiStore.isMobileSize) {
      uiStore.menuState.close();
    }
  }, [uiStore.isMobileSize]);

  return (
    <Button
      type={ComponentType.button}
      onClick={handleClick}
      className={className}
      size={ButtonSize.md}
      color={ButtonColor.purple}
      fullWidth
      withoutBorder
    >
      {(t) =>
        t('PageTemplate.ReferralButton', {
          ns: 'newComponents'
        })
      }
    </Button>
  );
};

export default observer(ReferralButton);
